var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_39661",
    "data-name": "\\uADF8\\uB8F9 39661",
    transform: "translate(-2103.382 -4001.382)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24693",
    "data-name": "\\uC0AC\\uAC01\\uD615 24693",
    width: 30,
    height: 30,
    transform: "translate(2103.382 4031.382) rotate(-90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_39657",
    "data-name": "\\uADF8\\uB8F9 39657",
    transform: "translate(2128.876 4013.146) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7904",
    "data-name": "\\uD328\\uC2A4 7904",
    d: "M1.272,20.986a1.272,1.272,0,0,1-.9-2.172l8.321-8.322L.373,2.171a1.272,1.272,0,0,1,1.8-1.8l9.22,9.221a1.272,1.272,0,0,1,0,1.8l-9.22,9.221a1.267,1.267,0,0,1-.9.373",
    transform: "translate(20.986 -4.75) rotate(90)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_48",
    "data-name": "\\uC120 48",
    y2: 19,
    transform: "translate(2118.383 4007.632)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrow);
export default __webpack_public_path__ + "static/media/white_arrow.66fc5bb2eeba0c4a99e52a0f1727721f.svg";
export { ForwardRef as ReactComponent };